export const dashboardImg = {
  src: '/new/simple-dashboard/dashboard.png',
};
